export default "__VITE_ASSET__tBsCWUx6__"